<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <vip-level-account-table></vip-level-account-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import vipLevelAccountTable from './VIPLevelAccountTable.vue'

  export default {
    name: 'vipLevelAccount',
    components: {vipLevelAccountTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/viplevel/VIPLevelAccount.vue